import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import favicon from "../Assets/Favicon.png";
import Post from "../../../Apis/backlink/Post";
import Get from "../../../Apis/backlink/Get";
import { getAPIUrlBM } from "../../../utils/config";
import loadingGif from "../Assets/loading.gif";

const Branding = () => {
  const [isLoading, setIsLoading] = useState(true);
  const fontFamilies = [
    "Arial",
    "Helvetica",
    "Times New Roman",
    "Times",
    "Courier New",
    "Courier",
    "Verdana",
    "Georgia",
    "Palatino",
    "Garamond",
    "Bookman",
    "Comic Sans MS",
    "Trebuchet MS",
    "Arial Black",
    "Impact",
  ];


  const [formData, setFormData] = useState({
    brandName: "",
    logoUrl: "",
    faviconUrl: "",
    brandColor: "#000000",
    fontFamily: "",
    fontSize: "",
  });


  useEffect(() => {
    (async () => {
      try {
        const url = getAPIUrlBM();
        const response = await Get(url + "/getBranding");
        console.log({ response });
        if (response.data?.length) {
          const { brandName, logoUrl, faviconUrl, brandColor, fontFamily, fontSize } = response.data[0];
          setFormData({
            brandName,
            logoUrl,
            faviconUrl,
            brandColor,
            fontFamily,
            fontSize,
          });
        }
        setIsLoading(false)
      } catch (error) {
        console.log(error)
      }
    })()
  }, [])

  console.log({ formData })

  const InputBoxHeader = ({ title, description }) => {
    return (
      <div>
        <p className="title">{title}</p>
        <p className="description">{description}</p>
      </div>
    );
  };

  const isValidUrl = (str) => {
    const matchpattern = /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)$/gm;
    return matchpattern.test(str);
  }


  const [formError, setFormError] = useState({
    brandName: {
      error: false,
      message: "",
    },
    logoUrl: {
      error: false,
      message: "",
    },
    faviconUrl: {
      error: false,
      message: "",
    },
    fontSize: {
      error: false,
      message: "",
    },
  })

  const isFormValid = () => {
    const {brandName, logoUrl, faviconUrl, fontSize} = formError;
    if(brandName.error || logoUrl.error || faviconUrl.error || fontSize.error){
      return false;
    }
    let isValid = true;
      if(!formData.brandName){
        console.log("insised brand name")
        isValid = false;
        setFormError(prev => ({
          ...prev,
          brandName : {
            error : true,
            message : "Brand name cannot be empty"
          }
        }))
      }
      if(!formData.logoUrl){
        isValid = false;
        setFormError(prev => ({
          ...prev,
          logoUrl : {
            error : true,
            message : "Logo Url cannot be empty"
          }
        }))
      }
      return isValid;
  }

  console.log({ formError })


  const handleChange = (e) => {
    let { name, value } = e.target;

    if (name === "brandName") {
      if (value.length > 255) {
        setFormError({
          ...formError,
          [name]: {
            error: true,
            message: "Brand Name should be less than 255 characters",
          },
        });
      } else if (value.length < 1) {
        setFormError({
          ...formError,
          [name]: {
            error: true,
            message: "Brand Name should not be empty",
          },
        });
      } else {
        setFormError({
          ...formError,
          [name]: {
            error: false,
            message: "",
          },
        });
      }
    } else if (name === "logoUrl" || name === "faviconUrl") {
      if (!isValidUrl(value)) {
        setFormError({
          ...formError,
          [name]: {
            error: true,
            message: "Invalid Url",
          },
        });
      } else {
        setFormError({
          ...formError,
          [name]: {
            error: false,
            message: "",
          },
        });
      }
    } else if (name === "fontSize") {
      console.log({ fontSize: value })
      if ((+value) < 1 || (+value) > 50) {
        setFormError({
          ...formError,
          [name]: {
            error: true,
            message: "Font Size should be in range 1 to 50 px",
          },
        });
      } else {
        setFormError({
          ...formError,
          [name]: {
            error: false,
            message: "",
          },
        });
      }
    }

    setFormData({ ...formData, [name]: value });
  }


  const handleSubmit = async () => {
    try {
      if (!isFormValid()) {
        window.sweet({
          text: "Please fill all the fields correctly",
          icon: "error",
        })
        return;
      }
      const url = getAPIUrlBM();
      const response = await Post(url + "/addBranding", formData);
      console.log({ response });
      if (response.status === "success") {
        window.sweet({
          text: response.data?.changedRows ? "Brand Updated Successfully" : "Brand Added Successfully",
          icon: "success",
        })
      } else if (response.status === "error") {
        window.sweet({
          text: response.message,
          icon: "error",
        })
      }
      
    } catch (error) {
      console.log(error)
    }
  };


  return (
    <>
      <Helmet>
        <title>Branding - Backlink Checker</title>
        {/* <meta
          name="description"
          content="Use backlink monitor to keep checking your backlinks & ensure they are not removed. After all, you paid for them with money, time or effort. Whenever you create a backlink, add it to Backlink Monitor to get notified if it is removed or edited and take necessary action proactively"
        /> */}
        {/* <meta property="og:image" key="og:image" content={"/og_backLink.jpg"} /> */}
        {/* <meta property="og:url" content="https://app.linkly.digital/" /> */}
        <link rel="icon" type="image/png" href={favicon} sizes="16x16" />

        <meta property="og:title" content="Branding - Backlink Checker" />
        {/* <meta
          property="og:description"
          content="Use backlink monitor to keep checking your backlinks & ensure they are not removed. After all, you paid for them with money, time or effort. Whenever you create a backlink, add it to Backlink Monitor to get notified if it is removed or edited and take necessary action proactively"
        /> */}
      </Helmet>
        {!isLoading ? (
          <div className="inputSection">
            <div className="inputSubSection">
              <InputBoxHeader
                title="Brand Name"
                description="Enter your brand name"
              />
              <input
                className="listInput"
                name="brandName"
                type="text"
                value={formData.brandName}
                onChange={handleChange}
                style={formError.brandName.error ? { border: "1px solid red" } : {}}
              />
              {formError.brandName.error && (
                <p className="errorInput">{formError.brandName.message}</p>
              )}
            </div>
            <div className="inputSubSection">
              <InputBoxHeader
                title="Brand Logo"
                description="Enter your brand logo url"
              />
              <input
                className="listInput"
                name="logoUrl"
                type="text"
                value={formData.logoUrl}
                onChange={handleChange}
                style={formError.logoUrl.error ? { border: "1px solid red" } : {}}
              />
              {formError.logoUrl.error && (
                <p className="errorInput">{formError.logoUrl.message}</p>
              )}
            </div>
            <div className="inputSubSection">
              <InputBoxHeader
                title="Brand favicon"
                description="Enter your brand favicon url"
              />
              <input
                className="listInput"
                name="faviconUrl"
                type="text"
                value={formData.faviconUrl}
                onChange={handleChange}
                style={formError.faviconUrl.error ? { border: "1px solid red" } : {}}
              />
              {formError.faviconUrl.error && (
                <p className="errorInput">{formError.faviconUrl.message}</p>
              )}
            </div>
            <div className="inputSubSection">
              <InputBoxHeader
                title="Brand Color"
                description="Choose your brand color"
              />
              <input
                className="listInput"
                name="brandColor"
                type="color"
                value={formData.brandColor}
                onChange={handleChange}
              />
            </div>
            <div className="inputSubSection">
              <InputBoxHeader
                title="Font Family"
                description="Choose your font family"
              />
              <select
                className="listInput"
                name="fontFamily"
                value={formData.fontFamily}
                onChange={handleChange}
              >
                <option value="">--Select--</option>
                {fontFamilies.map((font, i) => (
                  <option key={i} value={font}>{font}</option>
                ))}
              </select>
            </div>
            <div className="inputSubSection">
              <InputBoxHeader
                title="Font Size"
                description="Choose your font size"
              />
              <input
                className="listInput"
                name="fontSize"
                type="number"
                value={formData.fontSize}
                onChange={handleChange}
                style={formError.fontSize.error ? { border: "1px solid red" } : {}}
              />
              {formError.fontSize.error && (
                <p className="errorInput">{formError.fontSize.message}</p>
              )}
            </div>
            <button className="submitButton" onClick={handleSubmit}>
              Submit
            </button>
          </div>
        ) : (
          <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "89vh",
            margin: "-15px -30px",
          }}
        >
          <img
            style={{
              width: "82vw",
              height: "94vh",
            }}
            alt=""
            src={loadingGif}
          />
        </div>
        )}
    </>
  )
}

export default Branding